import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import CustomForm from '../../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../../../application/config/config';
import Fetch from '../../../../../core/util/core/Fetch';
import { chooseProfileFilter } from '../../../../helpers/chooseProfileFilter';
import sleep from 'sleep-promise';

function Form() {
    const profileFilter = chooseProfileFilter();

    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();
    const navigate = useNavigate();

    const path = '/people/';
    const paths = {
        endpointSave: config.endpoints.backend + 'people/save',
        endpointGetById: config.endpoints.backend + 'people/getById',
        endpointGetAllCompanies: config.endpoints.backend + 'companies/getAll',
        endpointGetAllBanks: config.endpoints.backend + 'banks/getall',
       
        endpointGetAllPeopleTypes:
            config.endpoints.backend + 'peopletypes/getall',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    };

    const labels = {
        labelTitleAdd: 'Nova Pessoa',
        labelTitleEdit: 'Editar Pessoa',
        labelTitleView: 'Visualizar Pessoa'
    };

    const hiddenValues = {};

    if (profileFilter.pdc_company_id) {
        hiddenValues.pdc_company_id = profileFilter.pdc_company_id;
    }

    const getForm = (values) => {
        let person_type = values.people_type;
        let form = {
            validateOnChange: true,
            hiddenValues: {
                ...hiddenValues
            },
            fields: [
                !hiddenValues.pdc_company_id
                    ? {
                          name: 'pdc_company_id',
                          type: 'select',
                          label: 'Empresa',
                          options: [],
                          optionsEndpoint: {
                              endpoint: paths.endpointGetAllCompanies,
                              label: 'corporate_name',
                              value: 'id',
                              params: {
                                  filter: {
                                      ...profileFilter
                                  }
                              }
                          },
                          validations: {
                              required: true
                          },
                          columnSize: 12
                      }
                    : {},
                {
                    name: 'people_type',
                    type: 'select',
                    options: [
                        { label: 'Física', value: 'F' },
                        { label: 'Jurídica', value: 'J' },
                        { label: 'Terceiro Setor', value: 'T' }
                    ],
                    label: 'Tipo de pessoa',
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                    handleChange: async (element, field, values) => {
                        let form = getForm(values);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />
                        );
                    }
                },
                ...(person_type === 'F'
                    ? [
                          {
                              name: 'name',
                              type: 'text',
                              label: 'Nome',
                              validations: {
                                  required: true
                              },
                              columnSize: 12
                          }
                      ]
                    : []),
                ...(person_type !== 'F'
                    ? [
                          {
                              name: 'corporate_name',
                              type: 'text',
                              label: 'Razão Social',
                              columnSize: 12,
                              validations: {
                                  required: false
                              }
                          },
                          {
                              name: 'fantasy_name',
                              type: 'text',
                              label: 'Nome Fantasia',
                              columnSize: 12,
                              validations: {
                                  required: false
                              }
                          }
                      ]
                    : [{}]),
                ...(person_type !== 'F'
                    ? [
                          {
                              name: 'estadual_registration',
                              type: 'text',
                              label: 'Inscrição Estadual',
                              validations: {
                                  required: false
                              },
                              columnSize: 6
                          },
                          {
                              name: 'cnpj',
                              type: 'CNPJ',
                              label: 'CNPJ',
                              validations: {
                                  required: false
                              },
                              columnSize: 6
                          }
                      ]
                    : [{}]),
                ...(person_type == 'F'
                    ? [
                          {
                              name: 'rg',
                              type: 'RG',
                              label: 'RG',
                              columnSize: 6,
                              validations: {
                                  required: false
                              }
                          },
                          {
                              name: 'cpf',
                              type: 'CPF',
                              label: 'CPF',
                              validations: {
                                  required: false
                              },
                              columnSize: 6
                          }
                      ]
                    : [{}]),
                {
                    label: 'Telefone',
                    type: 'phone',
                    name: 'phone',
                    columnSize: 6,
                    validations: {
                        required: false
                    }
                },
                ...(person_type == 'F'
                    ? [
                          {
                              name: 'birth_date',
                              type: 'date',
                              label: 'Data de Nascimento',
                              columnSize: 6,
                              validations: {
                                  required: true
                              }
                          }
                      ]
                    : [
                          {
                              name: 'opening_date',
                              type: 'date',
                              label: 'Data de Abertura',
                              columnSize: 6,
                              validations: {
                                  required: true
                              }
                          }
                      ]),
                {
                    name: 'contact',
                    type: 'text',
                    label: 'Pessoa de Contato',
                    columnSize: 6,
                    validations: {
                        required: false
                    }
                },
                {
                    label: 'E-mail',
                    type: 'email',
                    name: 'email',
                    columnSize: 6,
                    validations: {
                        required: false
                    }
                },
                {
                    name: 'status',
                    type: 'select',
                    options: [
                        { label: 'Ativo', value: '1' },
                        { label: 'Inativo', value: '0' }
                    ],
                    label: 'Ativo',
                    columnSize: 12,
                    validations: {
                        required: true
                    }
                },
                {
                    name: 'pdc_people_type_id',
                    type: 'select',
                    label: 'Categoria de Pessoa',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllPeopleTypes,
                        label: 'name',
                        value: 'id'
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                ...person_type == 'J'
                ? [{
                      name: 'cnd_files',
                      type: 'multiUploadFileS3',
                      label: 'Certidão de Débitos',
                      uploadPath: 'people/cnd_files',
                      extensionAccept: '.jpeg,.jpg,.png,.pdf',
                      limitFileSize: 2,
                      imageCompress: true,
                      validations: {
                          required: false
                      },
                      columnSize: 12
                  },{
                        name: 'cnd_validity',
                        type: 'date',
                        label: 'Validade da Certidão de Débitos',
                        columnSize: 6,
                        validations: {
                            required: false
                        }
                  }]
                : [{}]
            ],
            buttonsFooter: [
                {
                    label: 'Replicar Pessoa',
                    onClick: (form) => {
                        navigate(`/people/add/${form.values.id}`);
                    },
                    className: 'btn btn-primary'
                }
            ],
            ...paths,
            ...labels
        };
        form.values = values;
        return form;
    };

    useEffect(() => {
        const load = async () => {
            let values = await Fetch.post(paths.endpointGetById, { id: id });

            const form = getForm(values);

            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            );
        };
        load();
    }, []);

    return <div>{formContent}</div>;
}
export default Form;
